import React from 'react'
import { Checkbox, Col, Input, Radio, Row, Typography } from 'antd'
import { FormVoucherInfoProps } from './InterfaceForm'
import { DeliveryMethodEnum, VoucherDiscountTypeEnum } from 'generated/api'
import { classNameInput } from 'helpers/formik/classNameForm'
import { thousandSeparator, unThousandSeparator } from 'helpers/numbers'
import { regexNumber } from 'constants/regex'

export default function FormSection2(props: FormVoucherInfoProps) {
  const discountTypes = [
    {
      label: 'Nominal',
      value: VoucherDiscountTypeEnum.Nominal,
    },
    {
      label: 'Persentase',
      value: VoucherDiscountTypeEnum.Percentage,
    },
    {
      label: 'Persentase SawitPoin',
      value: VoucherDiscountTypeEnum.Sawitpoinpercentage,
    },
  ]

  const deliveryMethods = [
    {
      label: 'Ambil Sendiri',
      value: DeliveryMethodEnum.Pickup,
    },
    {
      label: 'Pengiriman',
      value: DeliveryMethodEnum.Delivery,
    },
  ]

  const getDiscountAmountLabel = () => {
    if (props.formikProps.values.discountType === VoucherDiscountTypeEnum.Nominal) {
      return 'Nominal Diskon'
    } else if (props.formikProps.values.discountType === VoucherDiscountTypeEnum.Percentage) {
      return 'Persentase'
    } else if (
      props.formikProps.values.discountType === VoucherDiscountTypeEnum.Sawitpoinpercentage
    ) {
      return 'Persentase SawitPoin'
    }
  }

  const changeDeliveryMethod = (value: DeliveryMethodEnum) => {
    const orderDeliveryMethods = props.formikProps.values.orderDeliveryMethods
    if (orderDeliveryMethods.includes(value)) {
      const newOrderDeliveryMethods = orderDeliveryMethods.filter(item => item !== value)
      props.formikProps.setFieldValue('orderDeliveryMethods', newOrderDeliveryMethods)
    } else {
      const newOrderDeliveryMethods = [...orderDeliveryMethods, value]
      props.formikProps.setFieldValue('orderDeliveryMethods', newOrderDeliveryMethods)
    }
  }

  return (
    <div className="flex flex-col gap-9">
      <Row gutter={[8, 8]}>
        <Col span={24} lg={6}>
          <Typography.Paragraph className="font-medium text-base mb-0">
            Tipe Promo
          </Typography.Paragraph>
        </Col>
        <Col span={24} lg={18}>
          <Radio.Group
            disabled={props.disabledForm}
            value={props.formikProps.values.discountType}
            onChange={e => {
              const value = e.target.value
              props.formikProps.setFieldValue('discountAmount', 0)
              props.formikProps.setFieldValue('maxDiscountPrice', 0)
              props.formikProps.setFieldValue('discountType', value)
            }}
          >
            <div className="flex">
              {discountTypes.map(item => (
                <Radio
                  key={item.value}
                  value={item.value}
                  data-testid={`radio_discountType_${item.value}`}
                >
                  {item.label}
                </Radio>
              ))}
            </div>
          </Radio.Group>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={24} lg={6}>
          <Typography.Paragraph className="font-medium text-base mb-0">
            {getDiscountAmountLabel()}
          </Typography.Paragraph>
        </Col>
        <Col span={24} lg={9}>
          <Input
            disabled={props.disabledForm}
            placeholder={
              props.formikProps.values.discountType === VoucherDiscountTypeEnum.Nominal
                ? 'Contoh: 1.000.000'
                : 'Contoh: 10'
            }
            data-testid="input_discountAmount"
            className={classNameInput('discountAmount', props.formikProps)}
            value={
              props.formikProps.values.discountAmount
                ? thousandSeparator(props.formikProps.values.discountAmount)
                : ''
            }
            onChange={({ target: { value } }) => {
              props.formikProps.setFieldTouched('discountAmount')
              const val = unThousandSeparator(value)
              if (regexNumber.test(val)) {
                props.formikProps.setFieldValue('discountAmount', Number(val))
              }
            }}
            status={
              props.formikProps.errors.discountAmount && props.formikProps.touched.discountAmount
                ? 'error'
                : ''
            }
            suffix={
              props.formikProps.values.discountType === VoucherDiscountTypeEnum.Percentage ||
              props.formikProps.values.discountType === VoucherDiscountTypeEnum.Sawitpoinpercentage
                ? '%'
                : false
            }
            prefix={
              props.formikProps.values.discountType === VoucherDiscountTypeEnum.Nominal
                ? 'Rp'
                : false
            }
          />
          {props.formikProps.errors.discountAmount && props.formikProps.touched.discountAmount ? (
            <Typography.Text
              className="text-[#FF4D4D] text-xs font-normal"
              data-testid="error_discountAmount"
            >
              {props.formikProps.errors.discountAmount}
            </Typography.Text>
          ) : null}
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={24} lg={6}>
          <Typography.Paragraph className="font-medium text-base mb-0">
            Minimal Total Tagihan
          </Typography.Paragraph>
        </Col>
        <Col span={24} lg={9}>
          <Input
            disabled={props.disabledForm}
            placeholder="10.000.000"
            data-testid="input_minTotalPrice"
            className={classNameInput('minTotalPrice', props.formikProps)}
            value={
              props.formikProps.values.minTotalPrice
                ? thousandSeparator(props.formikProps.values.minTotalPrice)
                : ''
            }
            onChange={({ target: { value } }) => {
              props.formikProps.setFieldTouched('minTotalPrice')
              const val = unThousandSeparator(value)
              if (regexNumber.test(val)) {
                props.formikProps.setFieldValue('minTotalPrice', Number(val))
              }
            }}
            prefix="Rp"
          />
        </Col>
      </Row>
      {props.formikProps.values.discountType === VoucherDiscountTypeEnum.Percentage ||
      props.formikProps.values.discountType === VoucherDiscountTypeEnum.Sawitpoinpercentage ? (
        <Row gutter={[8, 8]}>
          <Col span={24} lg={6}>
            <Typography.Paragraph className="font-medium text-base mb-0">
              Maksimal Diskon
            </Typography.Paragraph>
          </Col>
          <Col span={24} lg={9}>
            <Input
              disabled={props.disabledForm}
              placeholder="10.000.000"
              data-testid="input_maxDiscountPrice"
              className={classNameInput('maxDiscountPrice', props.formikProps)}
              value={
                props.formikProps.values.maxDiscountPrice
                  ? thousandSeparator(props.formikProps.values.maxDiscountPrice)
                  : ''
              }
              onChange={({ target: { value } }) => {
                props.formikProps.setFieldTouched('maxDiscountPrice')
                const val = unThousandSeparator(value)
                if (regexNumber.test(val)) {
                  props.formikProps.setFieldValue('maxDiscountPrice', Number(val))
                }
              }}
              prefix="Rp"
            />
          </Col>
        </Row>
      ) : null}
      <Row gutter={[8, 8]}>
        <Col span={24} lg={6} className="flex self-center">
          <Typography.Paragraph className="font-medium text-base mb-0">
            Metode Pengambilan
          </Typography.Paragraph>
        </Col>
        <Col span={24} lg={18}>
          <Row gutter={8}>
            <Col span={24} lg={8}>
              <Checkbox
                disabled={props.disabledForm}
                data-testid="checkbox_delivery_none"
                checked={props.formikProps.values.orderDeliveryMethods.length === 0}
                value=""
                className="px-2 py-4 shadow rounded-lg w-full"
                onClick={() => props.formikProps.setFieldValue('orderDeliveryMethods', [])}
              >
                Tidak ada pengambilan
              </Checkbox>
            </Col>
            {deliveryMethods.map(deliveryMethod => (
              <Col span={24} lg={8} key={deliveryMethod.value}>
                <Checkbox
                  data-testid={`checkbox_delivery_${deliveryMethod.value}`}
                  checked={props.formikProps.values.orderDeliveryMethods.includes(
                    deliveryMethod.value,
                  )}
                  value={deliveryMethod.value}
                  disabled={props.disabledForm}
                  className="px-2 py-4 shadow rounded-lg w-full"
                  onClick={() => changeDeliveryMethod(deliveryMethod.value)}
                >
                  {deliveryMethod.label}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  )
}

FormSection2.defaultProps = {
  disabledForm: false,
}
